import { graphql } from "gql";

const PROMOTE_PENDING_EMAIL_USERS_MUTATION = graphql(`
  mutation PromotePendingEmailUsers($id: ID!, $userIdList: [ID!]!) {
    promotePendingEmailUserIdList(id: $id, userIdList: $userIdList) {
      id
      pendingEmailUserIdList
      emailUserIdList
    }
  }
`);

export default PROMOTE_PENDING_EMAIL_USERS_MUTATION;
